import React from 'react';
import { Seo } from '../components/Seo';
import { Hero } from '../components/Hero';
import { Philosophy } from '../components/Philosophy';
import { Services } from '../components/Services';
import { Products } from '../components/Products';
import { InstagramReels } from '../components/InstagramReels';
import { Appointment } from '../components/Appointment';
import { buildMedicalBusinessJsonLd, clinicInfo } from '../data/clinicInfo';

export const Home: React.FC = () => {
  return (
    <>
      <Seo
        title="REHAM MANSOUR | קליניקה אסתטית וטבעית במושב פטיש"
        description={clinicInfo.description}
        path="/"
        jsonLd={buildMedicalBusinessJsonLd()}
      />
      <Hero />
      <Philosophy />
      <Services />
      <Products />
      <InstagramReels />
      <Appointment />
    </>
  );
};

